// new version
import { useEffect } from "react";
import { createChat } from "@n8n/chat";
import "@n8n/chat/style.css";
import "./App.css";

export const App = () => {
  useEffect(() => {
    // Initialize chat with two separate initial messages (so two bubbles appear)
    createChat({
      webhookUrl:
        "https://build.gjurchevski.com/webhook/5b4def72-b302-4a54-adac-dcdeacf6123a/chat",
      mode: "fullscreen",
      showWelcomeScreen: true,
      initialMessages: [
        "Hallo! 👋",
        "Mein Name ist Emma. Wie kann ich Ihnen heute helfen?"
      ],
      i18n: {
        en: {
          inputPlaceholder: "Stellen Sie Ihre Frage...",
        },
      },
    });

    // Modify the existing welcome content and button
    const chatGetStarted = document.querySelector(".chat-get-started");
    const existingButton = document.querySelector(".chat-button");
    if (chatGetStarted && existingButton) {
      chatGetStarted.insertAdjacentHTML(
        "beforeend",
        `
        <div class="chat-content">
          <h1 class="chat-title">Emma – Ihr intelligenter Assistent für Intralogistik & Materialfluss</h1>
          <p class="chat-description">Optimieren Sie Ihre Prozesse, steigern Sie Ihre Produktivität und erleben Sie, wie modernste KI Ihren Betrieb in neue Effizienz-Dimensionen führt.</p>
        </div>
      `
      );
      existingButton.textContent = "Neue Konversation";
      const chatContent = document.querySelector(".chat-content");
      chatContent.appendChild(existingButton);
    }
    const poweredByDiv = document.querySelector(".chat-powered-by");
    if (poweredByDiv) {
      poweredByDiv.innerHTML = "Copyright © 2025 i-Gentic";
    }

    // Helper: Typewriter effect on a text element
    function typeWriterHTML(element, html, callback) {
      element.innerHTML = "";
      let i = 0;
    
      function write() {
        if (i <= html.length) {
          element.innerHTML = html.slice(0, i);
          scrollToBottom();
          i++;
          setTimeout(write, 12); // Adjust speed
        } else if (callback) {
          callback();
        }
      }
    
      write();
    }
    

    // Animate bot messages that are already in the DOM (initial messages)
    function animateExistingMessages() {
      const botMessages = document.querySelectorAll(".chat-messages-list .chat-message-from-bot");
      botMessages.forEach((node, index) => {
        if (!node.classList.contains("animated")) {
          node.classList.add("animated", "message-slide-in");
          const markdownContainer = node.querySelector(".chat-message-markdown");
          const fullHTML = markdownContainer?.innerHTML || "";
          if (markdownContainer && fullHTML) {
            typeWriterHTML(markdownContainer, fullHTML);
          }
        }
      });
    }

    function scrollToBottom() {
      const messagesList = document.querySelector(".chat-messages-list");
      if (messagesList) {
        messagesList.scrollTo({
          top: messagesList.scrollHeight,
          behavior: "smooth",
        });
      }
    }

    function observeHeightChanges() {
      const container = document.querySelector(".chat-messages-list");
      if (!container) return;
    
      let lastHeight = container.scrollHeight;
    
      const resizeObserver = new ResizeObserver(() => {
        const newHeight = container.scrollHeight;
        if (newHeight > lastHeight) {
          lastHeight = newHeight;
          scrollToBottom();
        }
      });
    
      resizeObserver.observe(container);
    }
    
    

    // Set up a MutationObserver to animate new messages when they arrive
    const waitForMessagesList = setInterval(() => {
      const messagesList = document.querySelector(".chat-messages-list");
      if (messagesList) {
        clearInterval(waitForMessagesList);
        // Animate any initial messages already present
        animateExistingMessages();
        
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            Array.from(mutation.addedNodes).forEach((node, index) => {
              if (
                node.classList &&
                node.classList.contains("chat-message-from-bot") &&
                !node.classList.contains("animated")
              ) {
                // Apply slide animation to the bubble
                node.classList.add("animated", "message-slide-in");
                const markdownContainer = node.querySelector(".chat-message-markdown");
                const fullHTML = markdownContainer?.innerHTML || "";
                if (markdownContainer && fullHTML) {
                  scrollToBottom();
                  typeWriterHTML(markdownContainer, fullHTML);
                }
              }
            });
          });
        });

        observer.observe(messagesList, {
          childList: true,
          subtree: true,
        });
        observeHeightChanges();
      }
    }, 100);
  }, []);

  return <div id="n8n-chat-container"></div>;
};
